import React from "react";
import { Row, Col, Typography, Button, Space } from "antd";
import { useHistory } from "react-router-dom";
import {capitalize} from "utils/randomString"
const { Title, Link } = Typography;
export default function PageTitle({ data }) {
  const history = useHistory();
  return (
    <Row style={{ marginTop: "2em" }} justify="space-between" align="middle">
      <Col>
        <Title level={3} style={{margin:0}}>
          {capitalize(data?.buyer_name)} ,{capitalize(data?.buyer_country)}
        </Title>
        <Link type="secondary" href={data?.website} target="_blank">
          {" "}
          {data?.website}
        </Link>
      </Col>
      <Col>
        <Space>
          <Button
            size="large"
            type="primary"
            style={{
              color: "#0B7764",
              background: "#F0F8F6",
              border: "1px solid #0B7764",
            }}
            onClick={() => history.push("/prospects")}
          >
            View all prospects
          </Button>
          {/* <Button
            size="large"
            type="primary"
            style={{ background: "#363E3D", border: "0", color: "white" }}
          >
            Add as prospect
          </Button> */}
        </Space>
      </Col>
    </Row>
  );
}
